<template>
  <table class="table-hover reports-table attendance-report-table table">
    <AttendanceReportTableHeader :show-activity-percentage="showActivityPercentage" />

    <!--eslint-disable vue/require-v-for-key -->
    <template v-for="section in tableData.sections">
      <tbody class="grouping-header">
        <tr>
          <th>
            <template v-if="walker.main_type === 'date'">
              {{ $filters.formatDate(section.main) }}
            </template>
            <template v-else-if="walker.main_type == 'member'">
              <ReportTableAvatar
                :user-id="section.main_id"
                :url="section.rows[0].record.avatar_url"
              />
              {{ section.main }}
            </template>
            <template v-else>
              {{ section.main }}
            </template>
          </th>
          <td
            v-for="col in groupingColumnCount"
            :key="col"
          ></td>
        </tr>
      </tbody>

      <!-- eslint-disable vue/valid-v-for -->
      <ReportVirtualTableBody
        v-slot="{ row }"
        :rows="section.rows"
      >
        <tr>
          <td class="sticky-cell">
            <template v-if="walker.main_type === 'date'">
              <ReportTableAvatar
                :user-id="row.record.sub_id"
                :url="row.record.avatar_url"
              />
              {{ row.record.sub }}
            </template>
            <template v-else>
              {{ $filters.formatDate(row.record.sub) }}
            </template>
          </td>
          <td>{{ row.record.status_name }}</td>
          <td v-if="row.record.start_time && row.record.stop_time">
            {{ $filters.formatDatetimeRangeWithZone(row.record.start_time, row.record.stop_time, false, true) }}
          </td>
          <td
            v-else
            class="shift-cell"
          >
            N/A - N/A
          </td>
          <td v-if="row.record.actual_start_time">
            <span
              v-tooltip
              :title="$filters.formatDateTime(row.record.actual_start_time)"
            >
              {{ $filters.formatTimeWithZone(row.record.actual_start_time, false) }}
            </span>
          </td>
          <td v-else>N/A</td>
          <td>{{ $filters.formatDuration(row.record.minimum_time, 'auto', null, false, true) }}</td>
          <td>{{ $filters.formatDuration(row.record.actual_duration, 'auto', null, false, true) }}</td>
          <td v-if="showActivityPercentage">
            {{ formatActivityPercentage(row.record.activity_percentage) }}
          </td>
          <td v-if="row.record.status_name === 'Late'">
            {{ $filters.formatDuration(row.record.late, 'auto', null, false, true) }}
          </td>
          <td v-else>N/A</td>
        </tr>
      </ReportVirtualTableBody>
      <!-- eslint-enable vue/valid-v-for -->
    </template>
    <!--eslint-enable vue/require-v-for-key -->
  </table>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import AttendanceReportTableHeader from './AttendanceReportTableHeader.vue';

export default {
  name: 'AttendanceReportTable',
  components: {
    AttendanceReportTableHeader,
  },
  props: {
    tableData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['walker', 'tableIsTeam']),
    ...mapState(['organization']),
    showActivityPercentage() {
      return this.organization?.flags?.includes('attendance_report_activity_percentage') ?? false;
    },
    groupingColumnCount() {
      return this.showActivityPercentage ? 7 : 6;
    },
  },
  methods: {
    formatActivityPercentage(value) {
      return value === null || typeof value === 'undefined' ? '-' : `${value}%`;
    },
  },
};
</script>
